<template>
  <b-modal
    v-model="localShow"
    @hidden="handleHidden"
    id="cookie-consent-modal"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    centered
    headerClass="p-2 border-bottom-0"
    auto-focus-button="ok"
    no-stacking
    content-class="custom-modal"
  >
    <template v-slot:modal-header>
      <div class="mb-n3">
        <img
          :src="mmsLogoBlack"
          alt="MMS"
          class="logo"
        />
        <p class="header-title">{{ appName }} uses cookies</p>
      </div>
    </template>
    <div class="bread-text">
      <p>
        By continuing to use this website, you accept our privacy policy and consent to our use of cookies to ensure functionality and user experience.
      </p>

      <div class="link-list">
        <a
          href="https://mms.se/cookies/"
          target="_blank"
          rel="noopener noreferrer"
          >Read more about cookies</a
        >
        <a
          href="https://mms.se/om-oss/integritetspolicy/"
          target="_blank"
          rel="noopener noreferrer"
          >Read more about MMS privacy policy</a
        >
      </div>
    </div>
    <template v-slot:modal-footer>
      <div class="footer-container">
        <b-button
          variant="primary"
          @click="consentToCookies()"
          class="consent-button"
          >Accept</b-button
        >
      </div>
    </template>
  </b-modal>
</template>

<script>
import mmsLogoBlack from '@/assets/images/mms_logo_black.svg'
import { mapActions } from "vuex";
import globalConfig from "@/mixins/globalConfig";

export default {
  name: "CookieConsent",
  mixins: [globalConfig],
  data() {
    return {
      mmsLogoBlack,
      applicationHeading: ""
    };
  },
  async mounted() {
    await this.loadGlobalConfigFromFile();
    this.applicationHeading = this.config_ApplicationHeading;
  },
  computed: {
    localShow: {
      get() {
        return this.$store.getters.getShowCookieConsent;
      },
      set(value) {
        this.$store.commit("setShowCookieConsent", value);
      }
    },
    appName() {
      return this.$store.getters.getIsVideoInHomeSubdomain ? this.config_ApplicationHeadingVideoInHome : this.config_ApplicationHeading;
    }
  },
  methods: {
    ...mapActions(["consentToCookies"]),
    handleHidden() {
      this.$store.commit("setShowCookieConsent", false);
    }
  }
};
</script>

<style scoped>
.logo {
  width: 164px;
  margin-bottom: 1.5rem;
  transform: translateZ(0);
}

.header-title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 500;
}

.bread-text {
  font-size: 16px;
  padding: 0;
  margin-top: 1rem;
  margin-bottom: 2rem;
  color: gray;
}

.link-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 0.8rem;
  margin-top: 2rem;
}

.consent-button {
  background-color: #007bff;
  color: white;
  border: none;
  font-size: 18px;
  padding: 10px 20px;
  margin-top: 1rem;
  margin-bottom: -0.5rem;
  cursor: pointer;
}

.text-center {
  text-align: center;
}
.footer-container {
  display: flex;
  justify-content: center;
  width: 100%;
}
>>> .custom-modal {
  border-radius: 1rem !important;
  padding: 2rem;
}
>>> .modal-body {
  margin: 0.5rem;
  padding: 0;
}
</style>
